import * as React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';
import { DialogProps } from '~shared/components/Dialog';
import {
  PaywallDialog,
  PaywallTouch,
  PaywallUpgradeButton,
} from '~teacher/components/PaywallDialog';

export type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  paywallTouch: PaywallTouch;
};

export function ExportReportsPaywall(props: Props) {
  return (
    <PaywallDialog.Long
      id="export-reports-paywall"
      title={translate('Upgrade to Customize Reports')}
      actions={[
        <UIButton key="cancel" onClick={props.onClose}>
          {translate('Cancel')}
        </UIButton>,
        <PaywallUpgradeButton
          key="upgrade"
          appearance="primary"
          paywallScreen={props.paywallTouch[0]}
        />,
      ]}
      {...props}
    >
      <p className="m-0 pb-4 text-blue-900">
        {translate(
          'Include explanations, correct answers, and multiple choice answers in reports, or download answer keys.'
        )}
      </p>
    </PaywallDialog.Long>
  );
}
